
class QuotaLimitExceededError extends Error {
    constructor(message: string) {
      super(message);
      Object.setPrototypeOf(this, QuotaLimitExceededError.prototype);
    }
  }
  
  export default QuotaLimitExceededError
